// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"1b76d860","381":"1726c83b","399":"b563d0db","495":"dac216a5","748":"9a93c057"}[chunkId] + ".chunk.js";
};